import { Card } from "@/shared/components/ui/card"

export function PoliticaPrivacidadPage() {
  return (
    <div className="pt-32 pb-20 lg:pt-40 lg:pb-32">
      <div className="container mx-auto px-4 lg:px-8 max-w-8xl">
        <h1 className="text-4xl lg:text-6xl font-bold mb-8">Política de Privacidad</h1>

        <Card className="p-8 lg:p-12 space-y-8">
          <p className="text-xl-foreground leading-relaxed">
              En Rapyfact nos comprometemos a proteger la privacidad de nuestros usuarios y clientes. Esta Política de Privacidad explica cómo recopilamos, usamos, almacenamos y protegemos los datos personales conforme a la Ley 1581 de 2012 y sus decretos reglamentarios en Colombia.
            </p>
            <section className="space-y-4">
            <h2 className="text-3xl font-bold">1. Conceptos</h2>
            <ul className="list-disc list-inside space-y-2 text-xl-foreground leading-relaxed">
            <li><strong>Datos personales:</strong> Cualquier información que permita identificar a un usuario, como nombre, correo electrónico, número de teléfono, entre otros.</li>
    <li><strong>Datos de navegación:</strong> Información generada automáticamente cuando interactúas con nuestra web, como dirección IP, tipo de navegador, tiempo de visita y páginas consultadas.</li>
    <li><strong>Cookies y tecnologías similares:</strong> Pequeños archivos de datos almacenados en tu dispositivo para mejorar la experiencia de usuario y analizar el tráfico del sitio.</li>
    <li><strong>Usuario:</strong> Persona que accede y/o utiliza los servicios ofrecidos en nuestra web.</li>
    <li><strong>Proveedor de servicios:</strong> Terceros que nos asisten en la operación del sitio, como hosting, análisis de datos o soporte técnico.</li>
    <li><strong>Dirección IP:</strong> Una dirección IP es un número único que identifica a un dispositivo conectado a internet o a una red local.</li>
         </ul>
          </section>
          <section className="space-y-4">
            <h2 className="text-3xl font-bold">2. Información que Recopilamos</h2>
            <p className="text-xl-foreground leading-relaxed">
              Cuando visitas y utilizas nuestra Web, podemos recopilar diversos tipos de información con el objetivo de mejorar nuestros servicios, personalizar tu experiencia y garantizar la seguridad de la plataforma. Los datos que recopilamos pueden incluir:
            </p>
             <ol className="list-decimal list-inside space-y-2 text-xl-foreground leading-relaxed">
    <li>
      <strong>Datos personales:</strong> Incluyen cualquier información que nos proporciones de manera voluntaria a través de formularios de contacto, suscripción a boletines, registro en la Web o interacciones con nuestros servicios. Estos datos pueden ser:
    <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
      <li>Nombre y apellidos (para personalizar la comunicación).</li>
      <li>Correo electrónico (para enviar información relevante, notificaciones o responder consultas).</li>
      <li>Número de teléfono (si decides proporcionarlo para contacto directo).</li>
      <li>Dirección de facturación (cuando realizas transacciones en nuestra Web, aunque no almacenamos datos de tarjetas directamente, sino que los procesamos a través de plataformas seguras de pago).</li>
    </ul>
    </li>
    <li>
      <strong>Datos de navegación:</strong> Cuando accedes a nuestro sitio web, recopilamos automáticamente cierta información técnica y de comportamiento del usuario mediante herramientas de análisis. Estos datos incluyen:
    <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
     <li>Dirección IP(para identificar la región de acceso y mejorar la seguridad).</li>
     <li>Tipo y versión del navegador (para optimizar la compatibilidad de nuestra Web).</li>
     <li>Dispositivo y sistema operativo utilizado (para adaptar el diseño y funcionalidad).</li>
     <li>Páginas visitadas, tiempo de permanencia y acciones realizadas (para mejorar la experiencia del usuario y ofrecer contenido más relevante).</li>
    <li>Sitio de referencia (página desde la que accediste a nuestra Web).</li>
    </ul>
    </li>
    <li>
      <strong>Cookies y tecnologías similares:</strong> Utilizamos cookies y otras tecnologías de seguimiento para:
      <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
        <li>Recordar tus preferencias y configuraciones.</li>
        <li>Mejorar la navegación y funcionalidad del sitio.</li>
        <li>Ofrecer contenido y publicidad relevantes.</li>
        <li>Analizar el tráfico y el comportamiento de los usuarios en la Web.</li>
      </ul>
</li>
    
    
      </ol>
    
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold">3. Uso de la Información</h2>
            <p className="text-xl-foreground leading-relaxed">
              Utilizamos su información para proporcionar y mejorar nuestros servicios, procesar transacciones, enviar
              comunicaciones importantes, y cumplir con obligaciones legales y regulatorias según la Ley 1581 de 2012 de
              Colombia.
            </p>
            <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
              <li>Mejorar y personalizar la experiencia del usuario.</li>
              <li>Responder consultas y proporcionar soporte.</li>
              <li>Enviar comunicaciones relevantes si el usuario ha dado su consentimiento.</li>
              <li>Analizar el tráfico de nuestro sitio web mediante herramientas como Google Analytics.</li>
              <li>Garantizar la seguridad y el correcto funcionamiento de la Web.</li>
              <li>Cumplir con obligaciones legales y de seguridad.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold">4. Compartición de la Información</h2>
            <p className="text-xl-foreground leading-relaxed">
              No vendemos, alquilamos ni compartimos tu información personal con terceros, salvo en los siguientes casos:
            </p>
            <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
              <li>Cuando sea necesario para cumplir con la ley o responder a procesos legales.</li>
              <li>Con proveedores de servicios que nos ayuden en la operación de la Web.</li>
              <li>En caso de fusión, adquisición o venta de activos, donde la información pueda ser transferida a terceros.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold">5. Seguridad de la Información</h2>
            <p className="text-xl-foreground leading-relaxed">
             Implementamos medidas de seguridad adecuadas para proteger tu información personal contra accesos no autorizados, alteraciones o destrucción. Sin embargo, no podemos garantizar una seguridad absoluta en Internet.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold">6. Derechos del Usuario</h2>
            <p className="text-xl-foreground leading-relaxed">
              Tienes derecho a:
          
            </p>
            <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
              <li>Acceder, corregir o eliminar tu información personal.</li>
              <li>Retirar tu consentimiento en cualquier momento.</li>
              <li>Oponerte al procesamiento de tus datos personales en ciertas circunstancias.</li>
              <li>Oponerse al tratamiento de tus datos personales.</li>
            </ul>
          </section>
          <section className="space-y-4">
            <h2 className="text-3xl font-bold">7. Cookies y Tecnologías de Seguimiento</h2>
            <p className="text-xl-foreground leading-relaxed">
              Usamos cookies para mejorar la experiencia del usuario. Puedes gestionar la configuración de cookies desde tu navegador.
          
            </p>
            
          </section>
           <section className="space-y-4">
            <h2 className="text-3xl font-bold">8. Cambios en la Política de Privacidad</h2>
            <p className="text-xl-foreground leading-relaxed">
              Podemos actualizar esta Política de Privacidad en cualquier momento. Notificaremos cambios importantes mediante la Web o por correo electrónico.
            </p>
            
          </section>
          
           <section className="space-y-4">
            <h2 className="text-3xl font-bold">9. Ley Aplicable</h2>
            <p className="text-xl-foreground leading-relaxed">
              Esta Política de Privacidad se rige por la Ley 1581 de 2012 de Colombia, que regula la protección de datos personales y los derechos de privacidad de los ciudadanos.
            </p>
            <ol className="list-decimal list-inside space-y-2 text-xl-foreground leading-relaxed">
              <li>Ley de Protección de Datos Personales o Ley 1581 de 2012.</li>
              <p className="text-xl-foreground leading-relaxed">
              Reconoce y protege el derecho que tienen todas las personas a conocer, actualizar y rectificar las informaciones que se hayan recogido sobre ellas en bases de datos o archivos que sean susceptibles de tratamiento por entidades de naturaleza pública o privada.
            </p>
              </ol>
          </section>
          
           <section className="space-y-4">
            <h2 className="text-3xl font-bold">10. Contacto</h2>
            <p className="text-xl-foreground leading-relaxed">
              <br />Si tienes alguna pregunta sobre esta Política de Privacidad, puedes contactarnos en: soporte@rapyfact.com<br />
              <br />3135909091<br />
            </p>
            
          </section>
        </Card>
      </div>
    </div>
  )
}
